import Navbar from "./Navbar";

type Props = {
  readonly visible: boolean;
};

export default function SiteHeader({ visible }: Props) {
  return (
    <header
      className={[
        "fixed left-0 right-0 top-0 z-50 border-b border-border/60 bg-surface/75 backdrop-blur-xl transition-transform duration-300 ease-out",
        visible ? "translate-y-0" : "-translate-y-full",
      ].join(" ")}
    >
      <Navbar />
    </header>
  );
}
